<irembogov-data-table
  [columns]="field.props['columns'] || []"
  [formControl]="formControl"
  [pageSize]="pagination.size"
  [currentPage]="pagination.page"
  [collectionSize]="pagination.collectionSize"
  [pageSizeOptions]="field.props['pageSizeOptions'] || [10, 50, 100]"
  [asyncData]="field.props['asyncData'] || false"
  [loading]="loading"
  [searchable]="field.props['searchable'] ?? true"
  [selectable]="field.props['selectable'] ?? true"
  [minSelection]="field.props['minSelection']"
  [maxSelection]="field.props['maxSelection']"
  [emptyMessage]="field.props['emptyMessage'] || 'No Records'"
  [data]="field.props['items'] || []"
  [searchPlaceHolder]="field.props['searchPlaceHolder'] || 'Search'"
  [customTableClass]="field.props['customTableClass']"
  [title]="field.props['title']"
  [minimalPagination]="field.props['minimalPagination'] || false"
  (sortChanged)="handleSort($event)"
  (pageChanged)="handlePagnition($event)"
  (searchChanged)="handleSearch($event)"
  (selectionChanged)="handleSelection($event)">
</irembogov-data-table>
